import React from 'react'
import { ThemePreset } from '../../theme/presets'

export interface PageInfo {
  codigo: string
  nome: string
  ordem: number
}

interface TabBarProps {
  pages: PageInfo[]
  activePage: string
  onPageChange: (codigo: string) => void
  palette: ThemePreset
}

export const TabBar: React.FC<TabBarProps> = ({ pages, activePage, onPageChange, palette }) => {
  if (pages.length <= 1) return null

  return (
    <div className="flex border-b border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 rounded-t-xl">
      {pages
        .sort((a, b) => a.ordem - b.ordem)
        .map((page) => {
          const isActive = page.codigo === activePage
          return (
            <button
              key={page.codigo}
              onClick={() => onPageChange(page.codigo)}
              className={`relative px-5 py-3 text-sm font-medium transition-colors ${
                isActive
                  ? 'text-white'
                  : 'text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200'
              }`}
              style={
                isActive
                  ? { backgroundColor: palette.primary }
                  : undefined
              }
            >
              {page.nome}
              {isActive && (
                <span
                  className="absolute bottom-0 left-0 right-0 h-0.5"
                  style={{ backgroundColor: palette.primary }}
                />
              )}
            </button>
          )
        })}
    </div>
  )
}
